/* CEREMONIES */
export const GET_CEREMONIES_PACK = "GET_CEREMONIES_PACK"
export const GET_CEREMONIES_PACK_SUCCESS = "GET_CEREMONIES_PACK_SUCCESS"
export const GET_CEREMONIES_PACK_FAIL = "GET_CEREMONIES_PACK_FAIL"

/* CEREMONIES PROFILE */
export const GET_CEREMONY_PACK_PROFILE = "GET_CEREMONY_PACK_PROFILE"
export const GET_CEREMONY_PACK_PROFILE_SUCCESS = "GET_CEREMONY_PACK_PROFILE_SUCCESS"
export const GET_CEREMONY_PACK_PROFILE_FAIL = "GET_CEREMONY_PACK_PROFILE_FAIL"

/**
 * add CEREMONY_PACK
 */
 export const ADD_NEW_CEREMONY_PACK = "ADD_NEW_CEREMONY_PACK"
 export const ADD_CEREMONY_PACK_SUCCESS = "ADD_CEREMONY_PACK_SUCCESS"
 export const ADD_CEREMONY_PACK_FAIL = "ADD_CEREMONY_PACK_FAIL"

 /**
 * Edit CEREMONY_PACK
 */
export const UPDATE_CEREMONY_PACK = "UPDATE_CEREMONY_PACK"
export const UPDATE_CEREMONY_PACK_SUCCESS = "UPDATE_CEREMONY_PACK_SUCCESS"
export const UPDATE_CEREMONY_PACK_FAIL = "UPDATE_CEREMONY_PACK_FAIL"

/**
 * Delete CEREMONY_PACK
 */
export const DELETE_CEREMONY_PACK = "DELETE_CEREMONY_PACK"
export const DELETE_CEREMONY_PACK_SUCCESS = "DELETE_CEREMONY_PACK_SUCCESS"
export const DELETE_CEREMONY_PACK_FAIL = "DELETE_CEREMONY_PACK_FAIL"


